import { Slot } from "@radix-ui/react-slot";

import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  children: React.ReactNode;
  asChild?: boolean;
};

/**
 * Centers children in page.
 *
 * use --page-center-padding css variable to break out of the page center padding.
 * @example
 * // let the carousel break out of the page center padding
 * <CarouselContent className="-mx-(--page-center-padding) px-(--page-center-padding)">
 */
export function PageCenter({ className, children, asChild = false }: Props) {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp
      className={cn(
        "[--page-center-padding:20px] sm:[--page-center-padding:24px] lg:[--page-center-padding:0px]",
        "max-w-dvw px-(--page-center-padding) lg:w-page-width lg:mx-auto lg:px-0",
        className,
      )}
    >
      {children}
    </Comp>
  );
}
